import React from 'react';
import { CnLayoutCell as UICnLayoutCell } from '@/components/cn-layout';
import { enableDivider } from '@/lowcode/cn-layout-cell/enhance/callbacks';
const CnLayoutCell = (props) => {
    const { children } = props || {};
    return (<UICnLayoutCell style={{ height: '100%' }} onClick={() => {
            enableDivider();
        }}>
      {children}
    </UICnLayoutCell>);
};
CnLayoutCell.displayName = 'CnLayoutCell';
export default CnLayoutCell;
export { CnLayoutCell };
